<template>
  <div class="header-title">
    <IconWrapper :icon="icon" :theme="theme"></IconWrapper>
    <div class="title-content">
      <h1>{{ title }}</h1>
      <p v-if="description">{{ description }}</p>
    </div>
  </div>
</template>

<script>
import IconWrapper from "./IconWrapper.vue";
export default {
  components: {
    IconWrapper,
  },
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    icon: {
      type: String,
    },
    theme: {
      type: String,
    },
    text: {
      type: String,
    },
  },
};
</script>
<style lang="scss">
.header-title {
  color: #fff;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 0.35rem;
}

.title-content h1 {
  font-size: 1.35rem;
  font-weight: 600;
  margin-bottom: 4px;
  letter-spacing: -0.07em;
}

.title-content p {
  color: #94a3b8;
  font-size: 15px;
  margin-bottom: 0px;
  line-height: 1;
  letter-spacing: -0.065em;

  @media (max-width: 650px) {
    font-size: 13px;
    line-height: 1;
  }
}

@media (max-width: 768px) {
  .header-title {
    flex-direction: row;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .title-content h1 {
    font-size: 0.95rem;
    font-weight: 600;
    margin-bottom: 4px;
    letter-spacing: -0.07em;
  }
}
</style>
